
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/discovery",
      function () {
        return require("private-next-pages/brands/discovery/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/discovery"])
      });
    }
  